var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"appContainer"}},[(_vm.isAdmin)?_c('admin-bar',{attrs:{"offset":_vm.offset},on:{"update:offset":function($event){_vm.offset=$event}}}):_vm._e(),_vm._v(" "),_c('fade-transition',{attrs:{"mode":'out-in'}},[_vm._t("default")],2),_vm._v(" "),_c('sb-splash-screen',{attrs:{"id":"splashScreenStyle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }